/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { R7aUrceniEditoraZpsCreateUpdateRequest } from '../types/R7aUrceniEditoraZpsCreateUpdate';
import type { R7aUrceniEditoraZpsCreateUpdateResponse } from '../types/R7aUrceniEditoraZpsCreateUpdate';

export type R7UrceniEditoraZpsCreateRequest = R7aUrceniEditoraZpsCreateUpdateRequest;
export type R7UrceniEditoraZpsCreateResponse = R7aUrceniEditoraZpsCreateUpdateResponse;

export type R7UrceniEditoraZpsCreateQuery = {};

/**
 * POST /dmx-server/r7_urceni_editora_zps/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_create
 * tags:
 *   - r7_urceni_editora_zps
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsCreateOperation = (rest?: R7UrceniEditoraZpsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/r7_urceni_editora_zps/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/r7_urceni_editora_zps/' };
  };

/**
 * POST /dmx-server/r7_urceni_editora_zps/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_create
 * tags:
 *   - r7_urceni_editora_zps
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsCreateUpdate'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: R7UrceniEditoraZpsCreateQuery;
  request: R7aUrceniEditoraZpsCreateUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<R7aUrceniEditoraZpsCreateUpdateResponse>> => {
  const operation = r7UrceniEditoraZpsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
